import React, { useEffect } from 'react';
import { Row, Col, Button } from 'react-bootstrap';

import Cards from 'react-credit-cards';
import SetPaymentMethodButton from './SetPaymentMethodButton';
import W9FormButton from './W9FormButton';
import BankPreview from './BankPreview';
import CardPreview from './CardPreview';
import { useContext } from '../Context';

export default function Index() {
  const { dispatch, actions, state } = useContext();

  useEffect(() => {
    actions.loadPaymentMethod(dispatch, state.enterpriseId);
  }, []);

  return (
    <>
      <div className="inviteTabsCheckout_main">
        <div className="inviteTabsCheckoutMain_title">Payment Method</div>
      </div>
      <div className="invite-wrapper inviteTabsCheckout_control">
        <Row>
          <Col md={8}>
            <h4>
              Payment Method On File:
              {state.paymentMethod != null
              && (state.paymentMethod.attributes.payment_method_type == 'card'
                || state.paymentMethod.attributes.payment_method_type
                  == 'us_bank_account') ? (
                    <span className="green ml5">Verified</span>
                ) : (
                  <span className="text-danger ml5">Not Verified</span>
                )}
            </h4>

            {state.paymentMethod
              && state.paymentMethod.attributes.payment_method_type == '' && (
                <p>
                  We will provide you with an invoice containing payment
                  information until you set up an automatic payment method.
                </p>
            )}

            {state.paymentMethod
              && state.paymentMethod.attributes.payment_method_type == 'card' && (
                <CardPreview />
            )}
            {state.paymentMethod
              && state.paymentMethod.attributes.payment_method_type
                == 'us_bank_account' && <BankPreview />}
          </Col>
          <Col md={4} className="text-right">
            <SetPaymentMethodButton />
            <W9FormButton />
          </Col>
        </Row>
      </div>
    </>
  );
}
